import { IAppState } from '../appState';
import { UnfallZaehlstueck } from '../reducers/unfallZaehlstueckReducer';

export const selectUnfallProdukt = (state: IAppState): UnfallZaehlstueck => state.unfallZaehlstueck;
